export default function (close, vehicle, updateVehicle, toaster) {
    const vm = this;

    vm.details = Object.assign({}, vehicle);

    vm.closeModal = close;
    vm.submit = submit;

    function submit() {
        updateVehicle(vm.details.id, vm.details)
        .then(() => {
            Object.assign(vehicle, vm.details);
            toaster.success('Vehicle details have been updated successfully');
            close();
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/vehicles/edit/editVehicleCtrl.js